import { Injectable } from '@angular/core';
import { BaseMapper, BsServiceDto, CustomerDto, OrgUnitDto, ServiceDto, SpecialityDto } from '@shared/data';
import { BookingAllowanceInfoDto } from '../dto';
import {
    BookingAllowanceModel,
    BsServiceBookingModel,
    CustomerBookingModel,
    OrgUnitBookingModel,
    ServiceBookingModel,
    SpecialityBookingModel,
} from '../model';

@Injectable({
    providedIn: 'root',
})
export class BookingAllowanceMapper extends BaseMapper<BookingAllowanceModel, BookingAllowanceInfoDto> {
    public mapDtoToModel(dto: BookingAllowanceInfoDto): BookingAllowanceModel {
        return {
            allowancetoken: dto.token,
            maskedCustomerId: dto.maskedCustomerId,
            maskedBsId: dto.maskedBsId,
            customer: this.mapCustomerDtoToModel(dto.customer),
            service: this.mapServiceDtoToModel(dto.service),
            startDate: this.stringDateToDayjs(dto.startDate),
            prereservationId: dto.prereservationId,
            caseId: dto.caseId,
            bsId: dto.bsId,
            taxNo: dto.taxNo,
            contractorUuids: dto.contractorUuids,
        };
    }

    private mapCustomerDtoToModel(dto: CustomerDto): CustomerBookingModel {
        return {
            id: dto.id,
            externalId: dto.externalId,
            maskedId: dto.maskedId,
            kzz: dto.kzz,
            emso: dto.emso,
            taxNo: dto.taxNo,
            name: dto.name,
            surname: dto.surname,
            address: dto.address,
            email: dto.email,
            phone: dto.phone,
            mobile: dto.mobile,
            post: dto.post,
            city: dto.city,
            country: dto.country,
            birthDate: this.stringDateToDayjs(dto.birthDateString), // Assuming birthDateString is the source
            gender: dto.gender,
        };
    }

    private mapServiceDtoToModel(dto: ServiceDto): ServiceBookingModel {
        return {
            id: dto.id,
            externalId: dto.externalId,
            name: dto.name,
            description: dto.description,
            length: dto.length,
            orgUnit: dto.orgUnit ? this.mapOrgUnitDtoToModel(dto.orgUnit) : undefined,
            bsServices: dto.bsServices?.map(this.mapBsServiceDtoToModel.bind(this)),
            specialities: dto.specialities?.map(this.mapSpecialityDtoToModel.bind(this)),
            orgUnitExternalIds: dto.orgUnitExternalIds,
        };
    }

    private mapOrgUnitDtoToModel(dto: OrgUnitDto): OrgUnitBookingModel {
        return {
            externalId: dto.externalId,
            name: dto.name,
        };
    }

    private mapBsServiceDtoToModel(dto: BsServiceDto): BsServiceBookingModel {
        return {
            id: dto.id,
            name: dto.name,
        };
    }

    private mapSpecialityDtoToModel(dto: SpecialityDto): SpecialityBookingModel {
        return {
            id: dto.id,
            externalId: dto.externalId,
        };
    }
}
